import * as React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { useFeatureFlagWithStatus } from '../../../../shared/featureFlags/useFeatureFlagWithStatus';
import { FeatureFlagKeys } from '../../../../shared/featureFlags/featureFlagKeys';
import { getSiteName, Scandphotos } from '../../../../shared/Site';
import CustomerCalendarPage from './CustomerCalendarPage';

function CustomerCalendarWhenEnabled(props: RouteComponentProps) {
    const { value: isEnabled, isLoading } = useFeatureFlagWithStatus(
        FeatureFlagKeys.CustomerCalendar,
        false
    );

    if (isLoading) {
        return null;
    }

    if (!isEnabled || window.appConfig.site === getSiteName(Scandphotos)) {
        return <Redirect to="/" />;
    }

    return <CustomerCalendarPage {...props} />;
}

export default CustomerCalendarWhenEnabled;
